import React from 'react';
import "../styles/App.css"

const SiteHeader = () => (
  <div alt="Old Time Hockey" style={{width:"100%", height:"134px", backgroundImage:"url('/images/logos/banner.webp')", backgroundRepeat:"no-repeat", backgroundPosition:"center top", overflow:"hidden"}}>
  </div>
);

export default SiteHeader;
